@if(!isMobileDevice() || !isLoggedIn()) {
  <app-play-golf-landing></app-play-golf-landing>
}
@else {
<!-- chooseCourseList -->
<div class="chooseCourseList">
  @if(isLocationLoading()){
    <div class="finding-location">
      <span>{{'Finding Location...' | translate}}</span>
      <ng-lottie class="black-animation" [options]="animationOptions" />
    </div>
  }
  @else if(!isLocationLoading() && isLocationEnabled()){
  @if (!showSetting()) {
    <div class="d-block pt-3">
      <h2><b>{{getGreeting()}} {{firstName()}}</b>, Where are you playing today?</h2>
      <!-- chooseCourseList__box -->
      <div class="chooseCourseList__box d-flex overflow-hidden mt-4">
        @if (loading()) {
          @for (i of loadingArray; track i) {
            <div class="loadingItem">
              <div class="card me-4" drag-scroll-item>
                <div class="imgBg overflow-hidden">
                  <i style="height:145px;"></i>
                </div>
                <div class="card-body position-relative">
                  <h2 class="mb-1"><i class="h-auto">xxxxxxxxxx</i></h2>
                  <p><i class="h-auto w-50">xxxxx</i></p>
                  <i class="btn btn-outline w-100 mt-4 h-auto">Choose Course</i>
                </div>
              </div>
            </div>
          }
        } @else {
          <drag-scroll class="d-flex p-0 rounded-0">
            @for (course of courses(); track $index) {
              <div class="card" drag-scroll-item>
                <div class="imgBg overflow-hidden">
                  <img [src]="courseImagePaths[$index]" alt="Course Image">
                </div>
                <div class="card-body position-relative">
                  <span class="flag">
                    <img [src]="`https://flagsapi.com/${course.countryCode}/flat/64.png`" alt="" class="rounded-1">
                  </span>
                  <h2 class="mb-1">{{course.courseName}}</h2>
                  <p>{{course.countryFull}}</p>
                  <a href="javascript:void(0)" (click)="showCaddieSetting(course)"
                  class="btn btn-outline w-100 mt-4">Choose Course</a>
                </div>
              </div>
            }
          </drag-scroll>
          <!-- <div class="d-flex" [ngClass]="{'active': this.selectedCourse?.id_course === course.id_course}"
          (click)="selectCourse(course)" *ngFor="let course of courses; let i = index">
          <div class="col pe-2">
            <label
              [ngStyle]="{'color': this.selectedCourse?.id_course === course.id_course ? '#fff' : ''}">{{"Course"
              |
            translate}}:</label>
            <h4>{{course.courseName}}</h4>
          </div>
          <div class="layout_box">
            <label
              [ngStyle]="{'color': this.selectedCourse?.id_course === course.id_course ? '#fff' : ''}">{{"Layout"
              |
            translate}}:</label>
            <h4>{{course.layoutName}}</h4>
          </div>
        </div> -->
      }
      @if (noResult()) {
        <div class="d-flex">
          <div class="col">
            <div class="d-block">
              <p style="text-align: center;">{{'CoursesNotFould' | translate}}</p>
            </div>
          </div>
        </div>
      }
    </div>
    <!-- <div class="d-flex justify-center" *ngIf="hasMoreItems">
    <button (click)="!loading ? loadMoreCourses() : ''" class="loadmore">
      <div class="dotBg" *ngIf="loading">
        <div class="dot-flashing"></div>
      </div>
      <span *ngIf="!loading">{{'LoadMore' | translate}}</span>
    </button>
  </div> -->
  <!-- <button class="common-btn" *ngIf="courses.length > 0" (click)="showCaddieSetting()">{{"Next" |
translate}}</button> -->
</div>
}
@if (showSetting()) {
  <div class="col-lg-6">
    <div class="setting_head">
      <div class="d-flex justify-content-between mb-2">
        <img [src]="`https://flagsapi.com/${selectedCourse()?.countryCode}/flat/64.png`" alt="" class="rounded-1 flag">
        <!-- <a class="cursor-pointer" (click)="showSetting = false">
        <img src="/assets/images/close_icon.svg" alt="Close">
      </a> -->
    </div>
    <h2>{{selectedCourse()?.courseName}}</h2>
    <p>{{selectedCourse()?.city}}</p>
  </div>
  <!-- setting box -->
  <div class="chooseCourseList__settingbox flex-column">
    <h4 class="mb-3">{{'SetupRoundAt' | translate}}</h4>
    <drag-scroll class="d-flex">
      <div drag-scroll-item class="card text-center">
        <!-- Icon -->
        <div class="d-flex justify-content-center">
          <div class="icon_bg rounded-circle d-inline-flex align-items-center justify-content-center">
            <img ngSrc="assets/images/voiceIcon.svg" alt="" width="16" height="20">
          </div>
        </div>
        <!-- Title -->
        <h5 class="mt-2">{{'HandsFree' | translate}} {{customizeObj().onCourseAudio === 'on' ? ('on' | translate) : ('off' | translate)}}</h5>
        <!-- Toggle Buttons -->
        <div class="btnBg w-100">
          <button class="btn col" [ngClass]="{'active': customizeObj().onCourseAudio === 'on'}"
          (click)="setCustomize({ onCourseAudio: 'on' })">{{'on' | translate}}</button>
          <button class="btn col" [ngClass]="{'active': customizeObj().onCourseAudio === 'off'}"
          (click)="setCustomize({ onCourseAudio: 'off' })">{{'off' | translate}}</button>
        </div>
        <p class="text-start">
          {{'HandsFreeDesc' | translate}}
        </p>
      </div>
      <div drag-scroll-item class="card text-center">
        <!-- Icon -->
        <div class="d-flex justify-content-center">
          <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center position-relative">
            <img ngSrc="assets/images/competition_icon.svg" alt="" [ngClass]="{'active': customizeObj().onCourseMode === 'competition'}" width="24" height="24">
            <img ngSrc="assets/images/social_icon.svg" alt="" [ngClass]="{'active': customizeObj().onCourseMode === 'social'}" width="24" height="24">
          </div>
        </div>
        <!-- Title -->
        <h5 class="mt-2">{{customizeObj().onCourseMode === 'competition' ? ('Competition' | translate) : ('Social' | translate)}}</h5>
        <!-- Toggle Buttons -->
        <div class="btnBg w-100">
          <button class="btn col" [ngClass]="{'active': customizeObj().onCourseMode === 'competition'}"
          (click)="setCustomize({ onCourseMode: 'competition' })">{{'Competition' | translate}}</button>
          <button class="btn col" [ngClass]="{'active': customizeObj().onCourseMode === 'social'}"
          (click)="setCustomize({ onCourseMode: 'social' })">{{'Social' | translate}}</button>
        </div>
        <p class="text-start">
          {{'OnCourseModeDesc' | translate}}
        </p>
      </div>
      <div drag-scroll-item class="card text-center">
        <!-- Icon -->
        <div class="d-flex justify-content-center">
          <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center">
            <img ngSrc="assets/images/units_icon.svg" alt="" width="24" height="24">
          </div>
        </div>
        <!-- Title -->
        <h5 class="mt-2">{{'Units' | translate}} {{customizeObj().distance === 'meters' ? 'Meters' : 'Yards'}}</h5>
        <!-- Toggle Buttons -->
        <div class="btnBg w-100">
          <button class="btn col" [ngClass]="{'active': customizeObj().distance === 'yards'}"
          (click)="setCustomize({ distance: 'yards' })">{{'Yards' | translate}}</button>
          <button class="btn col" [ngClass]="{'active': customizeObj().distance === 'meters'}"
          (click)="setCustomize({ distance: 'meters' })">{{'Meters' | translate}}</button>
        </div>
        <p class="text-start">
          {{'DistanceDesc' | translate}}
        </p>
      </div>
    </drag-scroll>
  </div>
  <!-- setting -->
  <button class="common-btn w-100" [disabled]="isSettingSaving()" (click)="navigateToselectedId()">
    <!-- <img *ngIf="isSettingSaving" class="btn-img" src="/assets/images/loading-btn.svg" />
    <ng-container *ngIf="!isSettingSaving"> -->
      {{"StartRound" | translate}}
    <!-- </ng-container> -->
  </button>
</div>
}
}
@else
{
<div class="instructions_block pt-3">
  <!-- <div class="d-flex justify-content-end">
  <img src="assets/images/close_icon.svg" alt="Close">
</div> -->
<h4>Enable location</h4>
<div class="d-block">
  <p class="my-3">Enable location to use golf course features.</p>
  <p>How to enable on Android</p>
  <ul>
    <li>Click the <img ngSrc="assets/images/setting_location.svg" alt="Settings" width="24" height="24"> on the top left </li>
    <li>Select ‘Permissions’</li>
    <li>Enable the location toggle</li>
    <li>Refresh the page and lets play!</li>
  </ul>
</div>
</div>
<!-- Here need to show the instructions here -->
<!-- @if(isApple)
{
<h2 class="bold">Please enable location settings to use the on course feature.</h2>
<h4 class="mt-2 semi-bold">How to enable on iphone</h4>
<div class="row mt-2 px-2">
  <div class="col-lg-6 col-md-6 col-sm-6 col-6 px-2">
    <div class="d-flex align-items-start mt-3">
      <span class="number">1.</span>
      <p class="text italic">Navigate to Settings. <br />
        <span class="bold">> Privacy & Security</span> <br />
        <span>> Share My Location</span>
      </p>
    </div>
    <div class="d-flex align-items-start mt-3">
      <span class="number">2.</span>
      <p class="text">Enable <span class="bold">Location Services</span></p>
    </div>
    <div class="d-flex align-items-start mt-3">
      <span class="number">3.</span>
      <p class="text">Open <span class="bold">Safari Websites</span> and select <span class="bold">"While
    Using the App”</span></p>
  </div>
  <div class="d-flex align-items-start mt-3">
    <span class="number">4.</span>
    <p class="text">Enable <span class="bold">Precise Location</span></p>
  </div>
</div>
<div class="col-lg-6 col-md-6 col-sm-6 col-6 p-2 instruction-img">
  <img src="assets/images/iphone_location_instruction.gif" alt="android location instruction">
</div>
</div>
}
@else {
<h2 class="bold">Please enable location settings to use the on course feature.</h2>
<h4 class="mt-2 semi-bold">How to enable on Android</h4>
<div class="row mt-2 px-2">
  <div class="col-lg-6 col-md-6 col-sm-6 col-6 px-2">
    <div class="d-flex align-items-start mt-3">
      <span class="number">1.</span>
      <p class="text">Click the <img src="assets/images/and_icon.svg" class="icon-img"> icon on the top left
      corner.</p>
    </div>
    <div class="d-flex align-items-start mt-3">
      <span class="number">2.</span>
      <p class="text">Select <span class="bold">'Permissions'</span></p>
    </div>
    <div class="d-flex align-items-start mt-3">
      <span class="number">3.</span>
      <p class="text">Enable the location toggle.</p>
    </div>
    <div class="d-flex align-items-start mt-3">
      <span class="number">4.</span>
      <p class="text">Refresh the page.</p>
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-6 p-2 instruction-img">
    <img src="assets/images/android_location_instruction.gif" alt="android location instruction">
  </div>
</div>
} -->
}
<!-- }
@else{
<h2>{{"OncourseDeviceWarning" | translate}}</h2>
} -->
</div>
}